import {
  Component,
  OnInit
} from '@angular/core';

@Component ( {
    selector: 'reporter-body',
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.scss'],
    standalone: false
} )
export class BodyComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
